import { useState } from "react";

import {
  Button,
  DatePicker,
  Dropdown,
  DropdownProps,
  Input,
  TableColumnType,
} from "antd";
import { FilterOutlined, SearchOutlined } from "@ant-design/icons";
import { FilterSearchDropdown, FilterSelectDropdown } from "./Filter.component";

export const Filter = () => {
  const [open, setOpen] = useState(false);
  const handleOpenChange: DropdownProps["onOpenChange"] = (nextOpen, info) => {
    if (info.source === "trigger" || nextOpen) {
      setOpen(nextOpen);
    }
  };
  return (
    <Dropdown
      open={open}
      trigger={["click"]}
      onOpenChange={handleOpenChange}
      dropdownRender={() => (
        <div className="bg-white shadow-md border rounded-md px-4 py-2 grid grid-cols-2 gap-4">
          <div className="flex flex-col">
            <label>Name:</label>
            <Input id="input-name" size="small" />
          </div>
          <div className="flex flex-col">
            <label>Template:</label>
            <Input id="input-template-name" size="small" />
          </div>
          <div className="flex flex-col">
            <label>CoA:</label>
            <Input id="input-coa-name" size="small" />
          </div>
          <div className="flex flex-col">
            <label>Tags:</label>
            <Input id="input-tag-value" size="small" />
          </div>
          <div className="flex flex-col">
            <label>Created On:</label>
            <DatePicker id="input-date" size="small" />
          </div>
          <div className="flex flex-col">
            <label>Created By:</label>
            <Input id="input-creator-name" size="small" />
          </div>
          <div className="flex justify-end gap-2 col-span-2 mb-2">
            <Button id="apply-filter" size="small" type="primary" onClick={() => setOpen(false)}>
              Apply
            </Button>
            <Button id="reset-filter" size="small" onClick={() => setOpen(false)}>
              Reset
            </Button>
          </div>
        </div>
      )}
    >
      <Button icon={<FilterOutlined />}></Button>
    </Dropdown>
  );
};

export const getColumnSearchProps = (
  dataIndex: any,
  label: string,
  filterValue: any,
  setFilter: React.Dispatch<React.SetStateAction<any>>,
  isDate = false
): TableColumnType<any> => ({
  filterDropdown: ({ confirm, close }) => (
    <FilterSearchDropdown
      confirm={confirm}
      close={close}
      dataIndex={dataIndex}
      label={label}
      isDate={isDate}
      filterValue={filterValue}
      setFilter={setFilter}
    />
  ),
  filterIcon: (filtered: boolean) =>
    !isDate ? (
      <SearchOutlined style={{ color: filterValue ? "#1677ff" : undefined }} />
    ) : (
      <FilterOutlined style={{ color: filterValue ? "#1677ff" : undefined }} />
    ),
});

export const getColumnSelectProps = (
  dataIndex: any,
  label: string,
  options: { value: string | number; label: string }[],
  filterValue: string | number | null,
  setFilter: React.Dispatch<React.SetStateAction<any>>,
  isFiltered: boolean
): TableColumnType<any> => ({
  filterDropdown: ({ confirm, close }) => (
    <FilterSelectDropdown
      confirm={confirm}
      close={close}
      dataIndex={dataIndex}
      label={label}
      options={options}
      filterValue={filterValue}
      setFilter={setFilter}
    />
  ),
  filterIcon: () => (
    <FilterOutlined style={{ color: filterValue ? "#1677ff" : undefined }} />
  )
});
